import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IGeo } from './types';

export const getAll = (): Promise<void | AxiosResponse<Pick<IGeo, 'id' | 'name' | 'favorite'> []>> => axiosInstance({
  url: `${ROUTES.GEOS}/names`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getOneById = (id: string): Promise<void | AxiosResponse<IGeo>> => axiosInstance({
  url: `${ROUTES.GEOS}/${id}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const create = (data: IGeo): Promise<void | AxiosResponse<IGeo>> => axiosInstance({
  url: `${ROUTES.GEOS}/${data.id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const update = (data: IGeo): Promise<void | AxiosResponse<IGeo>> => axiosInstance({
  url: `${ROUTES.GEOS}/${data.id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const remove = (id: string): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.GEOS}/${id}`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});
